import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { Uploads } from "../../../services/uploads";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Events } from 'ionic-angular';
import { IngredientsServices } from "../../services";
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { StaticsServices } from '../../../services/statics';
import { HttpClient, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { AnalyticsServices } from '../../../services/analyticsServices';
import * as fuzzball from 'fuzzball';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { FinishProcessPage } from '../../../finish-process/finish-process';
import { AIServices } from '../../../services/aiServices';


/**
 * Generated class for the ingredientCreateImagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-comp-create-image',
  templateUrl: 'ingredient-comp-create-image.html',
})
export class IngredientCompCreateImagePage {

  update_state: boolean = false;
  ingredient_uid: string;
  img_ref: string = null;
  selectedFiles: FileList;
  ingredient_name: string;
  ingredient: any;

  show_alert: boolean = true;


  //variables para open ai
  aiimage: any = null;
  showOpenAI: boolean = true;
  loaderopenai: boolean = false;
  GeneretedInAI: boolean = false;
  aiAttempts: number = 0;
  color_buttonAI: boolean = false;
  Prompt: string = "";
  image_before: string = "";
  update_image: boolean = false;

  prompt: string
  description_user: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public uploadServices: Uploads,
    public IngredientsServices: IngredientsServices,
    private alertCtrl: AlertController,
    public events: Events,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public translate: TranslateService,
    public staticsServices: StaticsServices,
    private analyticsServices: AnalyticsServices,
    public http: HttpClient,
    public aiServices: AIServices) {

    this.update_state = this.navParams.get('update_state');
    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.img_ref = this.navParams.get('image');
    this.ingredient_name = this.navParams.get('ingredient_name');
    this.ingredient = this.navParams.get('ingredient');
    if (this.ingredient) {
      this.aiAttempts = this.ingredient.aiAttempts || 0;
    }
  }

  async selectFile(event) {
    const file = event.target.files.item(0);
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files; //File selected

      this.selectedFiles = this.globals.RenameFiles(this.selectedFiles, this.ingredient)


      this.img_ref = await this.uploadServices.uploadComplete(this.selectedFiles, 'ingredient') //Upload file to firbase storage
      this.getImageUrl(this.img_ref);//Get url from image uploaded
    }
    else {
      alert('invalid format!');
    }
  }

  getImageUrl(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.uploadServices.storage.ref(image_ref);
    this.IngredientsServices.image_url_ingr_view = ref.getDownloadURL();
  }


  getImageUrlAI(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    this.IngredientsServices.image_url_ingr_view = null;
    if (image_ref) {
      this.IngredientsServices.image_url_ingr_view = of(image_ref);
    }
  }

  //guardar en manual 
  update() {
    this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
      'image': this.img_ref,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      this.analyticsServices.trackingExpArticles('update ingredient', this.globals.tracking_exp['update_article'], this.ingredient_uid);
      if (this.update_state) {
        this.globals.GAtrackView('Ingredient', 'Ingredient - Image - Update', this.globals.restaurant.email, 'Create/Update', 'Update image', 'Ingredient', this.ingredient_name);
      } else {
        this.globals.GAtrackView('Ingredient', 'Ingredient - Image - Create', this.globals.restaurant.email, 'Create/Update', 'Create image', 'Ingredient', this.ingredient_name);
      }
      this.staticsServices.changeStateStaticWait(true);
    });
  }

  //para cambiar la imagen al salir del editor de la imagen
  async NoUpdate() {
    await this.getimageingredient();
    if (this.image_before) {
      this.getImageUrl(this.image_before);
    }
    else {
      this.IngredientsServices.image_url_ingr_view = null
    }
  }

  updateUserArrival() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
  }

  //para guardar en el boton de guardar
  async updateOrDelete() {
    try {
      if (this.IngredientsServices.image_url_ingr_view != null) {
        // si la imagen ya existe en el mostrador , solo hara el update ya que la imagen ya esta guradada en firebase
        if (this.GeneretedInAI) {
          await this.update()
          this.GeneretedInAI = false;
          this.update_image = true;
        }
        else {
          this.update()
          this.update_image = true;
        }
      } else {
        //si la imagen no esta en el mostrador , hace el update de borrar la imagen
        this.globals.GAtrackView('Ingredient', 'Ingredient - Image - Delete', this.globals.restaurant.email, 'Delete', 'Delete image', 'Ingredient', this.ingredient_name);
        this.uploadServices.delete(this.img_ref);
        this.img_ref = null;
        this.update();
      }
    } catch (error) { }
    finally {
      await this.openFinishIngredient()
    }
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-imagen'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Ingredient', 'Ingredient - Image - Delete', this.globals.restaurant.email, 'Delete', 'Delete image', 'Ingredient', this.ingredient_name);
            // this.uploadServices.delete(this.img_ref);
            this.IngredientsServices.image_url_ingr_view = null;
            // this.img_ref = null;
            //   this.update();
          }
        }
      ]
    });
    alert.present();
  }

  openFinishIngredient() {
    this.show_alert = false;
    this.globals.tourLaunchStep(6);
    //
    if (this.update_state) {
      this.navCtrl.pop();
    } else {
      this.IngredientsServices.image_url_ingr_view = null;
      this.navCtrl.push(FinishProcessPage, {
        uid_element: this.ingredient_uid,
        type: 'ingredient'
      });
    }
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'ingredient';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else if (this.update_state && !this.update_image) {
        this.NoUpdate();
        resolve();

      }

      else {
        resolve();
      }
    });
  }

  //mostrar el nuevo Row Text
  async Show() {
    //await this.GeneraPrompt();

    if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
      this.GeneraPorAi()
    }
    else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  //obtener Informacion antes del update 
  async getimageingredient() {
    if (this.ingredient && this.ingredient.image) {
      this.image_before = this.ingredient.image;
    } else {
      this.image_before = "";
    }
  }

  //para generar desde la AI
  async GeneraPorAi() {

    let contador = await this.contable();
    if (contador <= 3 || contador == undefined) {

      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('loader-generando-imagen')
      });
      loadingPopup.present();
      this.loaderopenai = true;
      await this.GeneraPrompt()
      let prompt: string = this.Prompt;
      try {
        //generar imagen
        const response = await this.aiServices.openAIGenerateImage(prompt);
        this.aiimage = response['data'][0]['url'];
        //mostrar la imagen visualmente
        try {
          await this.PostImageAIfb();
          await this.getImageUrlAI(this.aiimage);
          loadingPopup.dismiss();
        }
        catch (error) { }

      } catch (error) {
        this.Rebate()
        loadingPopup.dismiss();

        let alert = await this.alertCtrl.create({
          title: this.translate.instant('articulos-alert-timeout-title'),
          message: this.translate.instant('articulos-alert-timeout-text'),
          buttons: [
            {
              text: this.translate.instant('general-aceptar'),
              role: 'cancel',
              handler: () => {
              }
            },
          ]
        });

        alert.present()

      } finally {
        this.loaderopenai = false;
        this.GeneretedInAI = true;
      }

    }
  }

  getImage(image) {
    const imageParts = image.split('/');
    let url: string;
    if (imageParts.length > 1) {
      if (imageParts.length === 3) {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[1])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      } else {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      }
    } else {
      url = './assets/images/subir_imagen_v2_Mesa_de_trabajo_1_copia_7.png';
    }
    return url;
  }

  async sendMsgSlack() {
    var title = "AI IMAGE GENERATION INGREDIENT";
    var section = {
      "type": "section",
      "text": {
        "type": "mrkdwn",
        "text": ":hotel: " + this.globals.restaurant.company +
          "\n :email: " + this.globals.restaurant.email +
          "\n :mango: " + this.globals.nameLangSelectIngredient(this.ingredient) +
          "\n :keyboard: " + `${this.Prompt} ` +
          "\n :camera: " + `${this.getImage(this.img_ref)}` + "\n"
      }
    };
    this.globals.sendCustomerMctSlack(title, section);
  }

  //guardar imagen en firebase para poder guardarla en base de datos
  async PostImageAIfb() {
    try {
      const images_ai_controller = new HttpParams()
        .set('element_uid', this.ingredient_uid)
        .set('element_type', 'ingredient')
        .set('image_url', this.aiimage);
      const response_save = await this.http.post(this.globals.analytics_path + 'ai/images/save', images_ai_controller, {}).toPromise();
      this.img_ref = response_save['image_link'];
      this.sendMsgSlack();
    }
    catch (error) { }
    return this.img_ref;
  }

  //retoroseco de intentos
  async Rebate() {
    this.aiAttempts--;

    this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
      aiAttempts: this.aiAttempts
    });
  }


  //Contable de intentos
  async contable() {
    //cuando se acaban los intentos
    if (this.aiAttempts >= 3) {
      this.aiAttempts++;
      let alert = await this.alertCtrl.create({
        title: this.translate.instant('instant-limit-attention'),
        message: this.translate.instant('instant-limit-attention-description'),
        buttons: [
          {
            text: this.translate.instant('general-salir'),
            role: 'cancel',
            handler: () => {
            }
          },
        ]
      });
      alert.present();
    } else {
      //suma de contable hasta 3
      try {
        if (this.aiAttempts >= 1) {
          this.aiAttempts++;

          this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
            aiAttempts: this.aiAttempts
          });
        } else {
          this.aiAttempts++;
          await this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
            aiAttempts: 1
          });
        }
      }
      catch (e) { }
    }

    return this.aiAttempts;
  }

  async GeneraPrompt() {

    // obtenemos el producto si no existe
    if (!this.ingredient) {
      this.ingredient = await this.IngredientsServices.getIngredient(this.ingredient_uid)
    }

    // incializamos los tags de los prompts // los tags deben ser siempre los mismos entre la traduccion y la inicializaon de los tags
    var tags = ['bebidas', 'batidos', 'cafes', 'croissants', 'pastel', 'helado', 'paella', 'pizza', 'cocktail', 'cubata', 'combinado',
      'cubalibre', 'tapas', 'bocatas', 'bocadillos', 'sandwich', 'pinchos', 'vino', 'postres',
      'brasa', 'plancha', 'pescado', 'marisco', 'ensaladas', 'hamburguesas', 'sopa', 'Sushi', 'tacos', 'quesadilla',
      'cervezas', 'licores', 'plato combinado', 'tostadas',
      'tortilla', 'infusión', 'té', 'focaccia', 'cañas']

    // traducimos los tags segun la idioma del usuario y volvemos a obtener todos los tags segun el idioma
    var translatedTagsWithKeys = tags.map(tag => {
      return {
        key: tag,
        translated: this.translate.instant(`tags_ia.${tag}`)
      };
    });

    // cogemos el nombre del producto y lo separamos en cadena con una separacion de espacio
    let Query = this.globals.nameLangSelectIngredient(this.ingredient)
    let arrayDePalabras = Query.split(" ");

    // cogemos fuzbull y recorremos la cadena hasta encontrar algo que pueda coincidir al tag que tenemos
    // esto lo hacemos para evitar que no solo cogemos lo primero de la cadena , sino que buscamos en todo el texto para evitar problemas de idioma
    for (let i = 0; i < arrayDePalabras.length; i++) {
      let OptionsFuzz = {
        scorer: fuzzball.ratio,// Any function that takes two values and returns a score, default: ratio
        processor: choice => choice.translated,  // Takes choice object, returns string, default: no processor. Must supply if choices are not already strings.
        limit: 1, // Max number of top results to return, default: no limit / 0.
        cutoff: 79, // Lowest score to return, default: 0
        unsorted: false // Results won't be sorted if true, default: false. If true limit will be ignored.
        //  unsorted: false // Results won't be sorted if true, default: false. If true limit will be ignored.
      };
      // cuando encuentra un resultado coherente con buena classificion , para el bucle y cogemos el resultado
      var results = await fuzzball.extract(arrayDePalabras[i], translatedTagsWithKeys, OptionsFuzz);
      if (results.length > 0 && results[0][1] >= 79) {
        break;
      }
    }

    // descripcion para un tag esfecifico
    let descripcion = this.globals.descriptionLangSelectArticle(this.ingredient)
    // cogemos el resultado de la operacion y coge el prompt
    var choiceObjects = results.map(result => result[0]);

    if (choiceObjects.length > 0) {
      choiceObjects.forEach(choice => {
        switch (choice.key) {
          case 'bebidas':
            this.prompt = `
                
                Genera una imagen nítida y detallada de una lata de bebida refrescante en un estilo hiperrealista. La lata debe estar colocada en el centro de la imagen con una orientación que muestre claramente su logo y diseño distintivo. El logo debe ser vibrante y llamativo, resaltando en el diseño de la lata. Asegúrate de que la lata tenga un aspecto fresco, con gotas de condensación visibles, lo que enfatiza la frescura de la bebida. El fondo de la imagen debe ser blanco y sin distracciones, para garantizar que toda la atención se centre en la lata y su diseño. La iluminación debe ser tal que realce los colores y detalles del logo y de la lata.
                nombre de la bebida  : ${Query} ${this.description_user}`
            break;
          case 'batidos':
            this.prompt =
              `
                Genera una imagen hiperrealista y atractiva de un batido en un vaso alto y transparente. El batido debe lucir espeso y cremoso, con una textura suave y apetitosa. En la parte superior, añade una generosa cantidad de crema batida, junto con un adorno decorativo que sugiera frescura y sabor, como una rodaja de fruta o una hoja de menta. Alrededor del vaso, coloca algunos ingredientes relacionados con el sabor del batido, como frutas frescas, frutos secos o especias, según corresponda. El fondo de la imagen debe ser simple y neutro, permitiendo que el batido sea el protagonista absoluto de la escena. Por favor, enfoca en resaltar los colores vibrantes y la textura apetecible del batido."
                Nombre del Batido : ${Query}, ${this.description_user}
                `
            break;
          case 'cafes':
            this.prompt = `
              Genera una imagen elegante y detallada de una taza de café en un estilo hiperrealista. La taza debe estar en el centro de la imagen, con un diseño sofisticado y elegante que resalte la calidad del café. El café en la taza debe tener un aspecto rico y tentador, con una capa perfecta de crema en la superficie. Al lado de la taza, coloca algunos granos de café enteros y un pequeño molinillo o cafetera, lo que añadirá un toque auténtico a la escena. El fondo debe ser neutral y minimalista, enfocando toda la atención en la taza de café y sus detalles. Asegúrate de que la iluminación sea suave y acogedora, realzando la calidez y el aroma del café."
              Tipo de Café: ${Query}, ${this.description_user}
              `
            break
          case 'croissants':
            this.prompt = `
              Genera una imagen detallada y apetitosa de un croissant en un estilo hiperrealista. El croissant debe estar en el centro de la imagen, mostrando su textura dorada y hojaldrada con gran detalle. Resalta las capas crujientes y la mantequilla brillante en su superficie, lo que debe evocar una sensación de frescura y sabor. Al lado del croissant, coloca una taza pequeña de café o chocolate caliente, creando una composición que sugiera un desayuno o merienda tradicional. El fondo debe ser simple y elegante, con una paleta de colores neutros para mantener el foco en el croissant. La iluminación debe ser suave y cálida, realzando la textura y los colores del croissant y creando una atmósfera acogedora.
              Variante de Croissant : ${Query} ,${this.description_user}  `
            break
          case 'pastel':
            this.prompt = `
              Genera una imagen atractiva y detallada de un pastel en un estilo hiperrealista. El pastel debe estar en el centro de la imagen, mostrando claramente su textura esponjosa y el glaseado o decoración en la superficie. Resalta los detalles del pastel, como la suavidad del bizcocho, la riqueza del relleno (si lo tiene), y la creatividad en su decoración, que puede incluir frutas frescas, virutas de chocolate, o adornos florales. Asegúrate de que el pastel luzca apetitoso y tentador, como si estuviera listo para ser servido en una ocasión especial. El fondo debe ser simple y elegante, con una iluminación que realce los colores y las texturas del pastel sin distraer la atención de él.     
              tipo de pastel : ${Query}, ${this.description_user}
              `
            break
          case 'helado':
            this.prompt = `Genera una imagen vívida y atractiva de un helado en un estilo hiperrealista. El helado debe ser el enfoque principal de la imagen, mostrando claramente su textura suave y cremosa. Elige una presentación que destaque, ya sea en un cono crujiente, en una copa elegante, o en un plato sencillo, y asegúrate de que el helado se vea tentador y refrescante. Incluye detalles como gotas de helado derritiéndose ligeramente para añadir realismo. Resalta los colores vibrantes y naturales de los sabores del helado, ya sean frutales, de chocolate, vainilla o cualquier otro sabor. El fondo de la imagen debe ser neutro y minimalista, para no distraer la atención del helado. Una iluminación suave y natural ayudará a resaltar las texturas y los colores del helado.
                tipo de helado : ${Query}, ${this.description_user}`
            break

          case 'paella':
            this.prompt = `Genera una imagen cautivadora y detallada de una ${Query} en un estilo hiperrealista. La paella debe ser el enfoque principal de la imagen, mostrando claramente su rica mezcla de ingredientes y la textura perfectamente cocida del arroz. Elige una presentación que resalte la autenticidad y la complejidad de este plato tradicional español, ya sea en una paellera clásica o servida en un plato que enaltezca su apariencia. Asegúrate de que la paella se vea apetitosa y colorida, invitando a probarla. Incluye detalles como el arroz amarillo azafranado, trozos visibles de pollo o conejo, mariscos dispuestos artísticamente sobre el arroz, y verduras frescas que añadan contrastes de color. Considera la posibilidad de añadir elementos como ramas de romero o gajos de limón alrededor del plato para enriquecer la composición. El fondo de la imagen debe ser neutro y minimalista, para mantener el enfoque en la paella. Una iluminación suave y natural realzará las texturas y los vibrantes colores de los ingredientes.
                        tipo de paella: ${Query}, ${this.description_user}
                        `
            break

          case 'pizza':
            this.prompt = `Genera una imagen vibrante y apetecible de una pizza en un estilo hiperrealista. La pizza debe ser el foco central de la imagen, destacando su textura crujiente y los sabores ricos y fundidos que la caracterizan. Selecciona una presentación que realce la belleza rústica y la generosidad de ingredientes de este plato universalmente amado, ya sea en una piedra para pizza, en una bandeja de horno tradicional, o cortada en porciones listas para servir. Asegúrate de que la pizza luzca irresistible, con queso derretido estirándose y una variedad de toppings como tomate fresco, hojas de albahaca, pepperoni, champiñones, o cualquier otra elección que refleje la riqueza de sabores. Incorpora detalles como borde dorado y burbujeante, y tal vez un leve toque de aceite de oliva brillando sobre los ingredientes para añadir profundidad y realismo. El fondo de la imagen debe ser neutro y minimalista, enfocando toda la atención en la pizza. Utiliza una iluminación suave y natural para capturar la textura y los colores vivos de la pizza, mejorando su apariencia tentadora.
                        tipo de pizza: ${Query}, ${this.description_user}
                        `
            break
          case 'cocktail' || 'cubata' || 'combinado' || 'cubalibre':

            this.prompt = `Crear una imagen hiperrealista centrada en un vaso colocado en el centro sobre un fondo blanco puro. El vaso debe estar lleno de una bebida que represente uno de los siguientes productos: ${Query}  La iluminación debe resaltar la textura y el color de la bebida, mostrando detalles como el brillo, la transparencia del líquido, y cualquier adorno o detalle específico que estas bebidas suelen llevar (como rodajas de limón, una cereza, hielo, pajitas, o un borde escarchado).

                    Asegúrate de que la composición sea equilibrada, con el vaso perfectamente centrado, y que el detalle y la textura sean lo suficientemente ricos como para transmitir una sensación de realismo y tentación al espectador. La cámara debe estar a nivel del vaso, capturando la bebida desde un ángulo que muestre tanto el contenido como la forma del vaso de manera atractiva.
                    Especificaciones adicionales para personalización:
                    Tipo de bebida: ${Query}.
                    Detalles específicos: ${this.description_user}.`
            break
          case 'tapas':
            this.prompt = `Crea imágenes de tapas servidas en platos pequeños sobre un fondo blanco. Cada plato debe mostrar un ingrediente principal de manera artística y apetitosa. La iluminación debe ser natural, destacando las texturas y colores del ingrediente. Utiliza un ángulo superior para una composición simple y elegante.
                    Instrucciones para el Usuario:
                    ${Query} , ${this.description_user}`
            break

          case 'bocatas' || 'bocadillos':

            this.prompt = `genera una imagen de bocata,  que este muy poco relleno , el estilo de pan debe ser de vaquete francés

                    añade un ligero espolvoreo de aceite de oliva virgen extra sobre el bocadillo refleja sutilmente la luz, destacando la calidad y simplicidad de los ingredientes.
                   
                    El enfoque deber estar puesto firmemente en el bocadillo, con un ligero efecto de profundidad de campo que suaviza el fondo, asegurando que toda la atención se centre en la textura y los colores vivos de los ingredientes. La imagen debe transmitir una sensación de autenticidad y tentación, invitando al espectador a experimentar un sabor genuino de España en un bocado perfectamente equilibrado. 
                    detalles de la bocata / bocadillo : ${Query} , ${this.description_user}`

            break

          case 'sandwich':
            this.prompt = `genera una imagen de sandwich,  que este muy poco relleno , el sandwich debe ser al estilo americano de una sola capa sin añadir capas y sin rostro humano. destacando la calidad y simplicidad de los ingredientes. si  en los detalles del sándwich tiene queso , el  queso debe estar muy poco fundido y caliente, capturando el momento perfecto en el que el queso aún está caliente y burbujeante. El enfoque deber estar puesto al sandwich , con un ligero efecto de profundidad de campo que suaviza el fondo, asegurando que toda la atención se centre en la textura y los colores vivos del sandwich. La imagen debe transmitir una sensación de autenticidad y tentación, invitando al espectador a experimentar un sabor genuino en un sandwich perfectamente equilibrado. 
                    Detalles del sandwich: ${Query} , ${this.description_user} `
            break

          case 'pinchos':

            this.prompt = `Genera una imagen hiperrealista que muestre una selección exclusiva de ${Query}, sin incluir ningún otro tipo de ingredientes. Cada pincho debe presentar una variedad de ${Query}  coloridos y visualmente apetitosos, demostrando la rica diversidad de ${Query} en su forma más pura. Los pinchos deben estar elegantemente dispuestos en un plato redondo de color blanco, para mantener la atención en la vibrante selección de quesos. La cámara debe estar posicionada en un ángulo que capture tanto la disposición estética de los pinchos en el plato como la textura y los colores vivos de los diferentes ${Query}. La iluminación natural es esencial para resaltar la frescura y el atractivo visual de los pinchos, con un fondo blanco puro que evite cualquier distracción y mantenga el foco en los detalles de los ${Query}.
                    detalles de los pinchos : ${this.description_user}  `
            break
          case 'vino':
            this.prompt = `Genera una imagen hiperrealista de una botella de vino de alta calidad junto a un vaso de vino elegante, ambos sobre una superficie reflectante con un fondo completamente blanco. La botella debe estar parcialmente abierta, con el corcho visible a un lado, sugiriendo que acaba de ser descorchada. El vaso de vino, colocado al lado de la botella, debe estar lleno hasta la mitad, mostrando el rico color del vino, que capta la luz de manera que resalte su textura y tono. La composición debe ser simple y sofisticada, con un enfoque claro en la botella y el vaso de vino, permitiendo que el espectador aprecie la calidad y el color del vino. La iluminación debe ser natural y suave, diseñada para enfatizar el brillo del vino en el vaso y la textura de la etiqueta de la botella. La cámara debe estar a nivel del vino, capturando un ángulo ligeramente inclinado para añadir profundidad a la imagen y resaltar la forma del vaso y la botella.
                    detalles del vino : ${Query} , ${this.description_user} `
            break
          case 'postres':

            `Genera una imagen hiperrealista del postre de [flan de coco] el cual debe ser presentado de manera atractiva en un plato sobre un fondo blanco puro.  Asegúrate de que la imagen capture la esencia de esta descripción, mostrando las características principales que lo hacen especial. Utiliza iluminación natural para resaltar las texturas y colores del postre, haciendo que se vea lo más apetecible posible. El ángulo de la cámara debe ofrecer una vista clara y detallada del postre, enfocando en los elementos que lo hacen único según la mini descripción proporcionada
                    La descripción del postre es: ${Query} , ${this.description_user}`
            break
          case 'brasa' || 'plancha':
            this.prompt = `Genera una imagen de carne a la brasa asado o a la plancha cuidadosamente cocinado con un toque dorado y crujiente . El plato es para mostrar en una carta de restaurante, no le pongas muchos adornos y se cuidadoso en la forma de mostrarlo que no parezca que esté vivo: 
             ${Query} , ${this.description_user}`
          case 'pescado' || 'marisco':
            this.prompt = `Genera una imagen de ${Query} asado o a la plancha cuidadosamente cocinado con un toque dorado y crujiente . El plato es para mostrar en una carta de restaurante, no le pongas muchos adornos y se cuidadoso en la forma de mostrarlo que no parezca que esté vivo   
            Detalles : ${Query} ${this.description_user}`
            break

          case 'ensaladas':
            this.prompt = `Genera una imagen muy hiperrealista de una ensalada  ${Query} presentada de manera atractiva sobre un fondo blanco puro para resaltar su frescura y colores vibrantes. La imagen debe capturar la esencia y las características únicas de la ensalada, mostrando una variedad de los ingredientes de la ensalada  ${Query} . Utiliza iluminación natural para destacar las texturas crujientes y los colores vivos de los ingredientes, asegurando que la ensalada se vea lo más apetitosa y fresca posible. El ángulo de la cámara debe ofrecer una vista clara y detallada, enfocando en los elementos que hacen única a esta ensalada, como su combinación de ingredientes, el aderezo ligero y cualquier topping especial o mix de semillas.
                    Asegúrate de que la presentación visual evoca la calidad y la variedad de la ensalada, mostrándola en su estado más atractivo. La composición debe invitar al espectador a experimentar el equilibrio perfecto de sabores, texturas y colores que solo esta ensalada específica puede ofrecer              
                    detalles de la ensalada : ${Query} , ${this.description_user}`
            break
          case 'hamburguesas':
            this.prompt = `Genera una imagen hiperrealista de una hamburguesa de alta calidad, centrada en el medio de un fondo blanco puro para resaltar todos sus detalles apetitosos. La hamburguesa debe ser el foco principal de la imagen, asegurando que sea completamente visible sin distracciones alrededor. La carne de la hamburguesa necesita ser especialmente destacada por su hiperrealismo y calidad, mostrando texturas jugosas y un aspecto suculento que evidencie su excelente preparación.

                    Los detalles de la hamburguesa, como el pan tierno y ligeramente tostado, el queso derretido fluyendo suavemente por los bordes de la carne, y los vegetales frescos como lechuga crujiente y tomate brillante, deben ser visibles y contribuir a la apariencia general deliciosa de la hamburguesa. Utiliza iluminación natural para capturar y resaltar la riqueza de los colores y las texturas, desde el brillo del queso hasta la frescura de los vegetales, creando un contraste atractivo con el fondo blanco.  
                    El ángulo debe ser tal que ofrezca una vista clara y detallada de la hamburguesa, capturando la altura, la estructura y la combinación perfecta de ingredientes, asegurando que cada capa sea visible y contribuya a la tentadora presentación del plato."
                    Nombre de la hamburguesa y especificaciones:  ${Query} , ${this.description_user}`
            break

          case 'sopa':
            this.prompt = `Genera una imagen hiperrealista y detallada de una sopa caliente y apetitosa, servida en un cuenco de cerámica rústica que esté situado en el centro de la imagen contra un fondo blanco puro. La imagen debe enfocarse en capturar la riqueza y la variedad de colores de los ingredientes frescos y de alta calidad de la sopa, como verduras cortadas en trozos visibles, trozos de carne o legumbres, y un caldo claro u oscuro que invite a saborear con solo mirarlo.
                    Asegúrate de que la iluminación natural realce la textura humeante y reconfortante de la sopa, destacando gotas de condensación en el borde del cuenco como indicativo de su calidez. Los detalles apetitosos y la composición de la sopa deben ser los elementos centrales, mostrando una disposición armoniosa de los ingredientes que sugiera una preparación cuidadosa y un sabor delicioso. El ángulo de la cámara debe ser tal que ofrezca una vista superior que permita apreciar la profundidad del cuenco y la variedad de ingredientes, creando una invitación visual a disfrutar de este plato reconfortante.           
                    detalles del Sopa  y especificaciones: ${Query} , ${this.description_user} `

            break

          case 'sushi':

            this.prompt = `Genera una imagen hiperrealista de una selección de sushi, centrada en la imagen con un fondo blanco puro para resaltar su belleza y detalles apetitosos. La presentación debe incluir una variedad de sushi, como nigiri, sashimi, y maki, mostrando pescado fresco de colores vibrantes como el salmón, atún, y quizás algunos vegetales o adornos como caviar o flores comestibles para añadir un toque de elegancia.

                   Cada pieza de sushi debe ser detallada y hiperrealista, destacando la calidad de los ingredientes con texturas que inviten a degustarlos. La iluminación natural debe enfatizar el brillo natural del pescado y la suavidad del arroz, resaltando los cortes precisos y la habilidad culinaria detrás de la preparación del sushi.
                   
                   El enfoque de la cámara debe ofrecer una vista clara y detallada de la selección, con un ángulo que capture tanto la disposición artística del sushi en la bandeja o plato como la frescura y la calidad superior de los ingredientes. La composición de la imagen debe invitar al espectador a experimentar el equilibrio perfecto de sabores, texturas y colores que solo el sushi de alta calidad puede ofrecer.
                   detalles del sushi : ${Query} , ${this.description_user}  `


            break

          case 'tacos' || 'quesadilla':
            this.prompt = `Genera una imagen hiperrealista de una selección de tacos mexicanos, presentados de manera atractiva en el centro de la imagen con un fondo blanco puro para resaltar su apariencia colorida y apetitosa. Los tacos deben estar rellenos de ingredientes frescos y de alta calidad, mostrando una variedad que puede incluir carne asada, pollo, pescado, o incluso opciones vegetarianas, cada uno complementado con guarniciones clásicas como cilantro fresco picado, cebolla blanca, rodajas de lima, salsa roja o verde, y trozos de aguacate o guacamole.

                    Cada taco debe ser visible y detallado, destacando las texturas y colores de los ingredientes, desde el exterior crujiente o suave de las tortillas hasta el brillo jugoso de la carne o la frescura de los vegetales y salsas. La iluminación natural debe ser utilizada para enfatizar estos detalles, realzando el contraste y la riqueza visual que hace a los tacos tan irresistiblemente apetitosos.
                    
                    El enfoque de la cámara debe ofrecer una vista clara y detallada de los tacos, posiblemente desde un ángulo ligeramente elevado para mostrar el relleno generoso y la presentación cuidadosa de los tacos, invitando al espectador a experimentar la vibrante mezcla de sabores, texturas y colores que definen a este platillo icónico de la cocina mexicana.
                    Detalles específicos del taco : ${Query} , ${this.description_user} `
            break

          case 'Cervezas':

            this.prompt = `Genera una imagen hiperrealista de una jarra de cerveza fría, presentada en el centro de la imagen con un fondo blanco puro para resaltar su color dorado transparente y la espuma cremosa en la parte superior. La cerveza debe mostrar burbujas ascendentes sutiles que indiquen su frescura y carbonatación, capturando el momento perfecto en que parece más apetecible.

                   La iluminación natural debe incidir sobre la jarra para crear reflejos brillantes en la superficie líquida y resaltar la textura rica y aireada de la espuma, sugiriendo la suavidad y el sabor único de la cerveza. El vidrio de la jarra debe tener un ligero efecto de condensación, evidenciando la baja temperatura de la bebida y aumentando su apariencia refrescante.
                   
                   El ángulo de la cámara debe ofrecer una vista clara y detallada de la jarra, mostrando tanto la espuma como el cuerpo de la cerveza, invitando al espectador a experimentar la sensación de anticipación y placer que se asocia con el primer sorbo de una cerveza bien fría. La composición de la imagen debe capturar la esencia de disfrutar de una cerveza en un día caluroso, evocando sensaciones de frescura, satisfacción y convivialidad. 
                   Detalles específicos de cerveza : ${Query} , ${this.description_user}     `
            break

          case 'licores':

            this.prompt = `Genera una imagen hiperrealista de licor de Baileys, presentado de manera atractiva en el centro de la imagen con un fondo blanco puro para resaltar su color y calidad únicos. El licor debe estar servido en una copa o vaso específico que complemente perfectamente su tipo, capturando la esencia de una experiencia de degustación premium.
                    La iluminación natural debe incidir sobre la copa para crear reflejos y resaltar la textura líquida del licor, mostrando tonos que sugieran su sabor y calidad. Presta especial atención a los detalles que indican la exclusividad del licor, como la viscosidad evidenciada por la manera en que se adhiere a la copa y el licor y la claridad y pureza de la bebida.
                    El ángulo de la cámara,  debe ofrecer una vista detallada de la copa con el licor, posiblemente capturando la elegancia de la presentación y la invitación a degustar, con un enfoque que muestre claramente la textura y el color del licor. La composición de la imagen debe evocar un sentido de sofisticación y placer sensorial, invitando al espectador a experimentar la riqueza y la profundidad de sabores que licor de Baileys ofrece.
                    
                    Detalles específicos de cerveza : ${Query} , ${this.description_user} `
            break

          case 'plato combinado':

            this.prompt = `Crea una imagen hiperrealista de un plato combinado sencillo y apetitoso, servido en un plato redondo blanco de cerámica, ubicado en el centro de una mesa de madera bajo una iluminación cálida que realza los colores y texturas de la comida. El plato combinado debe contener los siguientes elementos, dispuestos de forma atractiva:
                    
                    Nombres : ${Query} ,
                    Descripción del plato: ${descripcion} , descripcion adicional:  ${this.description_user} `

            break
          case 'tostadas':

            this.prompt = `Crea una imagen hiperrealista que capture la esencia de un desayuno campestre y reconfortante. Centra la atención en dos tostadas de pan rústico, gruesas y con una textura artesanal, colocadas en un plato redondo de cerámica blanca. Este plato descansa sobre una mesa de madera natural, que irradia una sensación cálida y acogedora, como si estuviera bañada por el sol. La iluminación natural debe filtrarse delicadamente a través de una ventana cercana, bañando toda la escena con una luz suave que realza la textura crujiente del pan rústico y los colores vivos de los ingredientes sobre él. Esta luz debe conferir un brillo suave que haga destacar cada detalle de las tostadas, invitando no solo a verlas sino a sentir casi su textura y aroma. 
                    detalles de la tostada : ${Query} , ${this.description_user}`
            break
          case 'tortilla':

            this.prompt = `Crea una imagen hiperrealista que capture la esencia de un desayuno tradicional, enfocándose en la representación de una tortilla española esponjosa y apetitosa. Esta tortilla, dorada y jugosa, debe estar servida en un plato de cerámica blanca, 
                    que reposa sobre la superficie cálida y acogedora de una mesa de madera natural. La iluminación, proviniendo suavemente a través de una ventana cercana, debe realzar la textura y los colores del plato, otorgando un brillo suave que destaque el contraste entre el exterior dorado y el interior jugoso de la tortilla, revelando los diferentes ingredientes que componen su relleno, como cebolla caramelizada y pequeños trozos de pimientos verdes y rojos.
                    La imagen debe captar ese momento suspendido en el tiempo, justo cuando la tortilla ha sido recién cortada, permitiendo que el espectador casi pueda percibir los aromas y la tibieza del plato. Este momento capturado debe invitar al espectador a sentarse y disfrutar de esta experiencia culinaria, transmitiendo las sensaciones de hogar, tradición y sabor que evoca una tortilla española perfectamente realizada.
                    
                    detalles de la tortilla : ${Query} , ${this.description_user} `
            break
          case 'infusión' || 'te':

            this.prompt = `Crea una imagen donde el elemento central sea una tetera elegante, acompañada únicamente por un vaso transparente al lado, ambos destacando por su simplicidad. La tetera, hecha de un material claro que permita ver a través de ella, contendrá una infusion de hierbas visible y atractiva, con ingredientes naturales fácilmente reconocibles, como hojas de menta frescas, rodajas de limón, y pétalos de flores, que se vean sumergidos en el agua, creando un espectáculo visual de colores y formas. El vaso al lado mostrará una porción de esta infusión, creando una continuidad visual y temática. La imagen debe capturar la belleza de los ingredientes dentro de la tetera de manera que reclame tanto atención como el conjunto completo de la tetera y el vaso, sin perder el foco en la estética equilibrada de la escena. La iluminación jugará un papel importante para realzar los colores vibrantes de la infusión y los delicados detalles de los ingredientes, invitando a la contemplación y al disfrute visual. 
                    detalles de la infusiones/te : ${Query} , ${this.description_user} `
            break

          case 'focaccia':

            this.prompt = `
                    Genera una imagen de una focaccia deliciosamente apetitosa colocada en un plato elegante, asegurando que la focaccia sea el punto focal de la composición. La presentación debe invitar al apetito, destacando la textura y los colores vibrantes de la focaccia. Usa un fondo blanco puro para enfatizar la riqueza visual del plato, permitiendo que los detalles de la focaccia y su presentación capturen toda la atención.     
                    detalles de la focaccia :  ${Query} , ${this.description_user}`
            break

          case 'cañas':

            this.prompt = `Visualiza una sola caña de cerveza, presentada en su forma más elegante y pura. Esta caña debe capturar la esencia de una cerveza servida a la perfección, con un enfoque en la claridad y color de la bebida más que en la espuma. El nivel de la espuma es mínimo, formando apenas una capa delgada y uniforme en la parte superior, lo justo para acentuar su carácter sin dominar la escena. La caña está cuidadosamente colocada en el centro bajo una luz suave y equilibrada que ilumina la transparencia del vidrio y la tonalidad dorada de la cerveza, La cerveza misma debe ser de un color ámbar claro, con un aspecto limpio y fresco, y justo debajo de la delicada capa de espuma, pequeñas burbujas ascienden lentamente, añadiendo dinamismo y vida a la imagen. El vidrio de la caña es de estilo clásico, con una curvatura suave que se estrecha hacia el fondo, diseñado para realzar los aromas y sabores de la cerveza. Gotas de condensación se forman en el exterior del vidrio, detalladas con una precisión hiperrealista que puedes casi sentir la frialdad al tacto, sugiriendo que la cerveza está a la temperatura perfecta para ser disfrutada. El fondo de la imagen es de un blanco e inmaculado, creando un contraste impresionante que centra toda la atención en la caña de cerveza. Este enfoque minimalista enfatiza la singularidad y la belleza simple de la caña.
                    detalles de la cañas :  ${Query} , ${this.description_user}`
            break
          default:



            this.prompt = `
                Genera una imagen limpia y profesional de ${Query} en un estilo hiperrealista, ideal para su uso en un contexto de restaurante. El producto debe ser el foco principal de la imagen, presentado directamente en el centro. Si es una bebida, presenta el líquido en un vaso o copa adecuados, mostrando claramente su color y textura,.
                La imagen debe tener un fondo completamente blanco para eliminar distracciones y centrar toda la atención en el producto. Utiliza una iluminación que realce las cualidades del producto, mostrándolo apetitoso y atractivo. La composición debe ser equilibrada y estéticamente agradable, garantizando que el producto se vea invitante y sea el punto focal claro de la imagen.
            
                Detalles Específicos del Producto : ${Query} , ${this.description_user}`
            break;
        }
      });
    } else {
      this.prompt = `
      Genera una imagen limpia y profesional de ${Query} en un estilo hiperrealista, ideal para su uso en un contexto de restaurante. El producto debe ser el foco principal de la imagen, presentado directamente en el centro. Si es una bebida, presenta el líquido en un vaso o copa adecuados, mostrando claramente su color y textura,.
      La imagen debe tener un fondo completamente blanco para eliminar distracciones y centrar toda la atención en el producto. Utiliza una iluminación que realce las cualidades del producto, mostrándolo apetitoso y atractivo. La composición debe ser equilibrada y estéticamente agradable, garantizando que el producto se vea invitante y sea el punto focal claro de la imagen.
  
      Detalles Específicos del Producto : ${Query} , ${this.description_user}
      `;
    }

    this.Prompt = this.prompt

  }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-image/ingredient-comp-create-image.ts